// Redeem Modal
import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import config from "../../service/config";
import { arabicContent } from "../../constants/index";
import { useEffect, useRef, useState } from "react";
const lang = localStorage.getItem("language");
const alertTextBrand =
    config.clientName === "HDFC" ? "SmartBuy" : "Smartdeals";
const redirectSite = ({
    hide,
    item,
    baseURL,
    onRedeemInteraction
  }) => {
    hide();
    document.documentElement.style.overflowY = "hidden";
    document.body.style.overflowY = "hidden";
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-alert">
            {item.isOnline? 
            <h4 className="text-center">
              {lang === "AR"
                ? arabicContent.redirectMsg
                : `By clicking on 'Proceed' you are  providing  consent to  be redirected to the HDFC's website and ${alertTextBrand} holds no responsibility for any inconveniences or issues incurred hereafter`}
              </h4>:
              <h4 className="text-center">
                {'Please visit the store and use your HDFC bank credit card to avail the offer'}
                </h4>
              }
            <div className="custom-alert-button-group">
              {item.isOnline?
              <>
              <button
                onClick={() => {
                  onRedeemInteraction();
                  window.open(
                    !item.url ? `${baseURL}` : `${item.url}`,
                    "_blank"
                  );
                  document.documentElement.style.overflowY = "auto";
                  document.body.style.overflowY = "auto";
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.proceed : `Proceed`}
              </button>
              <button
                onClick={() => {
                  document.documentElement.style.overflowY = "auto";
                  document.body.style.overflowY = "auto";
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.cancel : `Cancel`}
              </button>
              </> :
              <button
              onClick={() => {
                document.documentElement.style.overflowY = "auto";
                document.body.style.overflowY = "auto";
                onClose();
              }}>Close</button>}
            </div>
          </div>
        );
      }
    });
};
export default redirectSite;